import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { Button } from '@penta/penta-shared';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import styles from './logout.module.scss'; // Import SCSS Module

export const Route = createFileRoute('/logout')({
  component: LogoutPage,
});

function LogoutPage() {
  const navigate = useNavigate();
  // Using translation hook if available, otherwise fallback to provided text
  const { t } = useTranslation();
  const { logout } = useAuth();

  useEffect(() => {
    logout();
  }, [logout]);

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>
          {t('logout.successMessage', 'Byli jste úspěšně odhlášeni')}
        </h1>

        <p className={styles.message}>
          {t(
            'logout.instruction',
            'Pro opětovný vstup do aplikace se prosím přihlaste.',
          )}
        </p>

        <div className={styles.buttonWrapper}>
          <Button
            onClick={() => navigate({ to: '/login' })}
            variant="primary"
            size="lg"
            className={styles.button}
            data-testid="logout-login-again-button"
          >
            {t('logout.loginAgain', 'Přihlásit se znovu')}
          </Button>
        </div>
      </div>
    </div>
  );
}
